var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_685_7108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7912 25.1291C27.0327 24.5285 28.3629 22.2246 27.7623 19.9831C27.1617 17.7416 24.8577 16.4114 22.6163 17.012C20.3748 17.6126 19.0446 19.9166 19.6452 22.1581C20.2458 24.3995 22.5498 25.7297 24.7912 25.1291Z",
    fill: "#C9F2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6693 39.7323C36.7386 37.5701 41.5273 29.2759 39.3651 21.2066C37.203 13.1374 28.9088 8.34869 20.8395 10.5109C12.7702 12.673 7.98153 20.9672 10.1437 29.0365C12.3058 37.1058 20.6001 41.8944 28.6693 39.7323Z",
    fill: "#C9F2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5441 35.0297C35.7866 32.9476 34.2762 31.2251 32.311 30.2019C30.3458 29.1787 28.0684 28.9292 25.9283 29.5027C23.7882 30.0761 21.9407 31.4308 20.7504 33.2995C19.56 35.1682 19.1133 37.4152 19.4983 39.5971",
    fill: "#C9F2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5441 35.0297C35.7866 32.9476 34.2762 31.2251 32.311 30.2019C30.3458 29.1787 28.0684 28.9292 25.9283 29.5027C23.7882 30.0761 21.9407 31.4308 20.7504 33.2995C19.56 35.1682 19.1133 37.4152 19.4983 39.5971M27.7623 19.9831C28.3629 22.2246 27.0327 24.5285 24.7912 25.1291C22.5498 25.7297 20.2458 24.3995 19.6452 22.1581C19.0446 19.9166 20.3748 17.6126 22.6163 17.012C24.8577 16.4114 27.1617 17.7416 27.7623 19.9831ZM39.3651 21.2066C41.5273 29.2759 36.7386 37.5701 28.6693 39.7323C20.6001 41.8944 12.3058 37.1058 10.1437 29.0365C7.98153 20.9672 12.7702 12.673 20.8395 10.5109C28.9088 8.34869 37.203 13.1374 39.3651 21.2066Z",
    stroke: "black",
    strokeWidth: 3.06692,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_685_7108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.3363,
    height: 40.3363,
    fill: "white",
    transform: "translate(0.0535889 10.8613) rotate(-15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.eaee4f3edb25b5fe28f63bb0ad934ca7.svg";
export { ForwardRef as ReactComponent };